if (!customElements.get('quantity-changer')) {
  customElements.define(
    'quantity-changer',
    class QuantityChanger extends HTMLElement {
      static observedAttributes = ['data-per-item-price'];

      constructor () {
        super();
        this.quantityEl = this.querySelector('quantity-input');
        this.priceEl = this.querySelector('[data-wpd-product-handle]');
        this.observer = new MutationObserver(this.wpdCallback.bind(this));
        this.initialPrice = 0;
        this.perItemPrice = this.moneyFormat(this.getAttribute('data-per-item-price'));
      }

      wpdCallback (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            let isWPD = false;
            mutation.addedNodes.forEach((node)=>{
              if(node?.classList?.contains('wpd-ext-compare-at-price')) {
                isWPD = true;
              }
            });
            if(isWPD) {
              this.setInitialPrice();
            }
          }
        }
      };
      moneyFormat(value) {
        let result = window?.WPDMoneyFormat.replace(/({{\s*amount\s*}})/g,
          (value / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        result = result.replace(/({{\s*amount_with_comma_separator\s*}})/g,
          (value / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        return result;
      };
      change (e) {
        const value = e.target.value;
        if (this.initialPrice > 0) {
          this.priceEl.innerText = this.moneyFormat(value * this.initialPrice);
        }
      }

      setInitialPrice () {
        const price = this.priceEl.innerText;
        let numericValue = price.replace(/[^0-9.]/g, '');
        this.initialPrice = Math.round(numericValue * 100);
        this.quantityEl?.input?.dispatchEvent(new Event('change'));
      }

      init () {
        if (!this.priceEl) {
          return;
        }
        this.quantityEl?.input?.addEventListener('change', this.change.bind(this));
        this.observer.observe(this.priceEl, {
          childList: true,
          characterDataOldValue: true,
        });
      }

      attributeChangedCallback(name, oldValue, newValue) {
        this.initialPrice = 0;
        this.perItemPrice = this.moneyFormat(newValue);
        this.priceEl = this.querySelector('[data-wpd-product-handle]');
        this.init();
      }

      disconnectedCallback () {
        this.quantityEl?.input?.removeEventListener('change', this.change.bind(this));
      }
    },
  );
}
